import { LinkedDataConnectors } from '@types'

import { useNotifications } from '@/plugins/notification'

import { useLinkedDataConnectorsStore } from '@/store/linkedData/connectors'

export const connectAccount = async (
  source: string,
  data: { name: string; institution_id?: string; logo?: string | null }
) => {
  return new Promise<{ name: string; url: string; logo?: string | null }>(async (resolve, reject) => {
    let connector: LinkedDataConnectors | undefined = undefined
    const params: Record<string, string> = {}

    switch (source) {
      case 'akoya':
        connector = LinkedDataConnectors.AKOYA
        params.connector = data.institution_id || ''
        break
      case 'carta':
        connector = LinkedDataConnectors.CARTA
        break
      case 'coinbase':
        connector = LinkedDataConnectors.COINBASE
        break
      default:
        break
    }

    const { error } = useNotifications()

    if (!connector) {
      error({
        message: 'Connector not available',
      })
      reject()
      return
    }

    const linkedDataConnectorsStore = useLinkedDataConnectorsStore()
    const url = await linkedDataConnectorsStore.getUrl(connector, params)
    if (!url) {
      error({
        message: `${source
          ?.charAt(0)
          .toUpperCase()}${source?.slice(1)} URL not available`,
      })
      reject?.()
      return
    }

    resolve({ name: data.name, url, logo: data.logo })
  })
}
